import { useParams } from "react-router-dom";
import blogsData from "../constants/blogs";

const BlogDetail = () => {
    const { slug } = useParams();
    const blog = blogsData.find((item) => item.slug.toString() === slug);

    if (!blog) {
        return <div className="text-center py-10 text-red-500">Blog not found.</div>;
    }

    return (
        <div className="max-w-4xl mx-auto px-4 py-8 prose prose-lg mt-12 md:mt-14">
            {/* Blog Title */}
            <h1 className="text-3xl font-bold mb-2">{blog.title}</h1>
            <p className="text-sm text-gray-500 mb-6">
                {blog.date} • {blog.author}
            </p>

            {/* Featured Image */}
            <img
                src={blog.featuredImage}
                alt={`blog title ${blog.alt}`}
                title={`blog title ${blog.title}`}
                className="rounded-2xl shadow-lg my-6 w-full"
            />

            {/* Blog Intro */}
            <h2 className="text-2xl font-semibold mt-6">Introduction</h2>
            <p>{blog.introduction}</p>

            {/* Restaurants/Spots */}
            {blog.restaurants.map((res, idx) => (
                <section key={idx} className="mt-10 border-t pt-6">
                    <h2 className="text-xl font-semibold mb-2">{res.name}</h2>
                    {res.price && <p className="font-medium">Price: {res.price}</p>}
                    <p className="italic mb-2">Interior: {res.interior}</p>

                    <h3 className="font-semibold mt-4">Food Highlights</h3>
                    <ul className="list-disc pl-6">
                        {res.foodHighlights.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>

                    <h3 className="font-semibold mt-4">Why Visit</h3>
                    <p>{res.whyVisit}</p>
                </section>
            ))}
        </div>
    );
};

export default BlogDetail;
